/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SkillScape API
 * API для системы управления компетенциями SkillScape
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Error,
  User
} from '../model';

import { customAxios } from '../../mutator/customAxios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type getUsersMeResponse200 = {
  data: User
  status: 200
}

export type getUsersMeResponse401 = {
  data: Error
  status: 401
}

export type getUsersMeResponse404 = {
  data: Error
  status: 404
}

export type getUsersMeResponse500 = {
  data: void
  status: 500
}

export type getUsersMeResponseSuccess = (getUsersMeResponse200) & {
  headers: Headers;
};
export type getUsersMeResponseError = (getUsersMeResponse401 | getUsersMeResponse404 | getUsersMeResponse500) & {
  headers: Headers;
};

export type getUsersMeResponse = (getUsersMeResponseSuccess | getUsersMeResponseError)

export const getGetUsersMeUrl = () => {




  return `/users/me`
}

/**
 * @summary Получение профиля текущего пользователя
 */
export const getUsersMe = async ( options?: RequestInit): Promise<getUsersMeResponse> => {

  return customAxios<getUsersMeResponse>(getGetUsersMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUsersMeQueryKey = () => {
    return [
    `/users/me`
    ] as const;
    }


export const getGetUsersMeQueryOptions = <TData = Awaited<ReturnType<typeof getUsersMe>>, TError = Error | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersMe>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersMe>>> = ({ signal }) => getUsersMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersMeQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersMe>>>
export type GetUsersMeQueryError = Error | void


export function useGetUsersMe<TData = Awaited<ReturnType<typeof getUsersMe>>, TError = Error | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersMe>>,
          TError,
          Awaited<ReturnType<typeof getUsersMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersMe<TData = Awaited<ReturnType<typeof getUsersMe>>, TError = Error | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersMe>>,
          TError,
          Awaited<ReturnType<typeof getUsersMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersMe<TData = Awaited<ReturnType<typeof getUsersMe>>, TError = Error | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersMe>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Получение профиля текущего пользователя
 */

export function useGetUsersMe<TData = Awaited<ReturnType<typeof getUsersMe>>, TError = Error | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersMe>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






